import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from './client';

/* ---------- Hangar's architecture map (plan P25, operators only) ---------- */

export const ArchitectureMap = z.object({
  available: z.boolean(),
  url: z.string().nullable(),
  expiresAt: z.string().nullable(),
  renderedAt: z.string().nullable(),
});
export type ArchitectureMap = z.infer<typeof ArchitectureMap>;

export const getArchitectureMap = () => api('GET', '/platform/architecture', { schema: ArchitectureMap });

/** The link lasts 15 minutes and the frame loads it once: fetched again only when the page opens again after 10. */
export const useArchitectureMap = (enabled: boolean) =>
  useQuery({ queryKey: ['platform', 'architecture'], queryFn: getArchitectureMap, enabled, staleTime: 10 * 60_000, gcTime: 10 * 60_000 });
